import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { get } from 'lodash';
import clsx from 'clsx';
import { AsyncView } from 'components';

import { isLoading, hasError } from 'utils/meta-selectors';

import { useSnackbar } from 'hooks';
import {
  getCurrentProductEndpoints,
  getCurrentProductHeaders,
} from '../RoleProducts/duck/selectors';

import { getResources, getActions, getSettings } from './duck/actions';
import {
  getActionsGroupedByActionType,
  getProductActionsOptions,
  getScopeFromSettings,
} from './duck/selectors';
import ModelsTable from './ModelsTable';
import ProductAccessSwitcher from './ProductAccessSwitcher';
import styles from './ModelsPermissions.scss';

const ModelsPermissions = () => {
  const dispatch = useDispatch();
  const productScope = useSelector(getScopeFromSettings);
  const { hash } = window.location;
  const [, , , , , appSlug] = hash.split('/');
  const { endpoints, headers } = useSelector((state) => ({
    endpoints: getCurrentProductEndpoints(state, appSlug),
    headers: getCurrentProductHeaders(state, appSlug),
  }));
  const setSnackbar = useSnackbar();

  useEffect(() => {
    if (endpoints && productScope !== appSlug) {
      if (endpoints.resources) {
        dispatch(getResources(endpoints.resources, headers, setSnackbar));
      }
      if (endpoints.settings) {
        dispatch(getSettings(endpoints.settings, headers));
      }
      if (endpoints.actions) {
        dispatch(getActions(endpoints.actions, headers));
      }
    }
  }, [endpoints, headers]);

  const resources = useSelector((state) => state.productResources);
  const settings = useSelector((state) => state.productSettings);
  const actions = useSelector((state) => state.productActions);
  const isLoadingData = useSelector((state) =>
    isLoading(state, ['productResources', 'productSettings', 'productActions']),
  );
  const hasErrorLoading = useSelector((state) =>
    hasError(state, ['productResources', 'productSettings', 'productActions']),
  );
  const resourceOptions = useSelector(getActionsGroupedByActionType);
  const productOptions = useSelector(getProductActionsOptions);

  const hasApplicationLevelPermission =
    get(settings.value, 'allowed_actions', []).length === 1;

  return (
    <div className={styles.permissionsContainer}>
      <AsyncView
        loading={isLoadingData}
        error={hasErrorLoading && 'Could not load data for permissions table!'}
      >
        {hasApplicationLevelPermission && (
          <div className={styles.accessSwitcher}>
            <ProductAccessSwitcher
              settings={settings.value}
              options={productOptions}
            />
          </div>
        )}
        {!!resources.list.length && (
          <ModelsTable
            className={clsx(
              hasApplicationLevelPermission && styles.tableWithAccessSwitcher,
            )}
            actionsOptions={resourceOptions}
            isLoading={resources.loading || actions.loading}
          />
        )}
      </AsyncView>
    </div>
  );
};

export default withRouter(ModelsPermissions);
